import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";

const ActionDropdown = ({ actions = [], triggerIcon }) => {
  const menu = (
    <Menu>
      {actions.map(({ key, label, icon, danger, onClick }) => (
        <Menu.Item key={key} icon={icon} danger={danger} onClick={onClick}>
          {label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <Button type="text" icon={triggerIcon || <EllipsisOutlined />} />
    </Dropdown>
  );
};

export default ActionDropdown;